import Icon, { IconBg } from './Icon';

export { IconBg };
export default Icon;
